import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { clearSuccess } from '@store/UI/toastSlice';
import { CircleCheck, CircleXmark } from '@assets/index';
import styles from './Toast.module.scss';
const Toast = ({ id, message }) => {
    const dispatch = useDispatch();
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        setVisible(true);
        const timer = setTimeout(() => {
            setVisible(false);
            setTimeout(() => dispatch(clearSuccess(id)), 300);
        }, 5000);
        return () => clearTimeout(timer);
    }, [id, dispatch]);
    if (!message)
        return null;
    return (_jsxs("div", Object.assign({ className: `${styles.toast} ${visible ? styles.show : ''}`, "data-testid": "toast" }, { children: [_jsx("div", { children: _jsx("img", { src: CircleCheck, className: styles.toast__icon }) }), _jsx("p", Object.assign({ className: styles.toast__text }, { children: message })), _jsx("button", Object.assign({ className: styles.toast__xmark, onClick: () => dispatch(clearSuccess(id)), "aria-label": "Close toast" }, { children: _jsx("img", { src: CircleXmark }) }))] })));
};
export default Toast;
